import React from 'react';

const Terms = () => (
    <div style={{margin:'10px',padding:'10px'}}>
        <h1>Terms & Conditions</h1>
        <p style={{fontSize:"20px"}}>
        All the products and the price is shown on our website is regularly updated. It is the customer's responsibility to provide the correct address and contact details of the recipient. We are not responsible for delay in delivery or no show on delivery date and time due to incorrect information in the order. All payments are processed by 3rd party payment gateway (PayPal and 2checkout). We are an online food and gift delivery service and we do not produce any of the products that we supply. Any health issue caused by any product is not our responsibility. We will disclose the full details of the supplier or producer to our customers.
        </p>
    </div>
)
export default Terms;